import { defineMessages } from 'react-intl'

/* eslint-disable max-len */

export default defineMessages({
  title: 'From legacy to innovation: <br /> making IT systems <b>fit for the future</b>',
})
